import React, { useState } from 'react';
import {
  Select,
  MenuItem,
  FormControl,
  ListItemText,
  InputLabel,
  Checkbox
} from '@mui/material';
import { useTheme } from '@mui/system';
import {
  isSingleCategoryAll,
  defaultCategories,
  categoryAll
} from '@utils/index';

import { OptionType } from '@types';

interface FilterCategorySelectProps {
  categoryFilters: OptionType[];
  onChange: (val: OptionType[]) => void;
  categories: [string, number][];
}

const FilterCategorySelect = ({
  categoryFilters,
  categories,
  onChange
}: FilterCategorySelectProps) => {
  const theme = useTheme();
  const [categoryFilterOpen, setCategoryFilterOpen] = useState(false);
  const handleClose = () => {
    setCategoryFilterOpen(false);
  };

  const handleFilterChange = (category: OptionType) => {
    const { value } = category;
    const currentFilters = categoryFilters;

    if (value === categoryAll.value) {
      console.log('hit this case 1');
      onChange(defaultCategories);
      setCategoryFilterOpen(false);
      return;
    }

    const filterOutAll = currentFilters.filter(
      (filter) => filter.value !== categoryAll.value
    );

    const hasCategory = currentFilters.some(
      (filter) => filter.value === category.value
    );

    if (!hasCategory) {
      // Add the filter if it's checked and not already in the array
      onChange([...filterOutAll, category]);
      return;
    }

    // Remove the filter if it's unchecked
    const newestFilters = currentFilters.filter(
      (filter) => filter.value !== category.value
    );

    // if removing the last filter than add back the all filter
    onChange(newestFilters.length === 0 ? defaultCategories : newestFilters);

    if (newestFilters.length === 0) {
      setCategoryFilterOpen(false);
    }
  };

  const categoryIsSelected = (value: string) => {
    return categoryFilters.some((category) => category.value === value);
  };

  return (
    <FormControl size="small" fullWidth>
      <InputLabel
        style={{
          backgroundColor: theme.palette.background.paper,
          padding: '0 6px'
        }}
        id="subscribe-save-filter-by-select-label"
      >
        Category
      </InputLabel>
      <Select
        labelId="subscribe-save-filter-by-select-label"
        aria-labelledby="subscribe-save-filter-by-select-label"
        multiple
        value={categoryFilters}
        renderValue={(selected) =>
          selected.reduce((str, select) => {
            return str.length === 0 ? select.label : `${str}, ${select.label}`;
          }, '')
        }
        autoWidth
        open={categoryFilterOpen}
        onOpen={() => setCategoryFilterOpen(true)}
        onClose={handleClose} // Close the menu when a selection is made
      >
        <MenuItem
          disableGutters
          value="none"
          onClick={() => handleFilterChange(categoryAll)}
          sx={{
            padding: '0 16px 0 7px'
          }}
        >
          <Checkbox
            checked={
              categoryFilters.length === 1 &&
              isSingleCategoryAll(categoryFilters[0])
            }
          />
          <ListItemText primary="Show all categories" />
        </MenuItem>
        {categories.map((category) => {
          const [label, amount] = category;
          const displayLabel = `${label} (${amount})`;
          return (
            <MenuItem
              key={label}
              value={label}
              disableGutters
              onClick={() =>
                handleFilterChange({
                  label,
                  value: label
                })
              }
              sx={{
                padding: '0 16px 0 7px'
              }}
            >
              <Checkbox checked={categoryIsSelected(label)} />
              <ListItemText primary={displayLabel} />
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default FilterCategorySelect;
